import Localize from 'react-intl-universal';

import * as yup from 'yup';

// TODO we will use this when registration will work properly
// import { PASSWORD_REGEX } from '@common/Constants';

export default () => {
  return yup.object().shape({
    email: yup
      .string()
      .email(Localize.get('Validation.emailFilter'))
      .required(Localize.get('Validation.requiredField')),
    password: yup.string().required(Localize.get('Validation.requiredField'))
    // .min(8, Localize.get('MyProfile.minCharacter'))
    // .matches(PASSWORD_REGEX, Localize.get('Validation.missingCondition'))
  });
};
